import type { UserPermissions } from "Infrastructure/Api/permissions";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { useUser } from "Settings/User/Api/Query/useUserProfileQuery";
import { AuthErrorPage } from "Shared/Pages/Error/AuthError";
import { Box, CircularProgress } from "@mui/material";
import type { FC, ReactNode } from "react";

export type UserPermissionKeys = typeof UserPermissions;
export type UserPermissionValues =
	UserPermissionKeys[keyof UserPermissionKeys][keyof UserPermissionKeys[keyof UserPermissionKeys]];

type PermissionGuardProps = {
	permission: UserPermissionValues | UserPermissionValues[];
	children: ReactNode;
	fallback?: ReactNode;
};

export const PermissionGuard: FC<PermissionGuardProps> = ({
	permission,
	children,
	fallback = <AuthErrorPage />,
}) => {
	const { user, isLoading } = useUser();

	const hasUserPermission = hasPermission(permission);

	if (isLoading && !user)
		return (
			<Box
				width="100%"
				display="flex"
				height="100vh"
				alignItems="center"
				justifyContent="center"
			>
				<CircularProgress />
			</Box>
		);
	if (!isLoading && !hasUserPermission) return <>{fallback}</>;
	return <>{children}</>;
};
